import { useEffect, useMemo, useState } from 'react';
import { Headphones, Phone, Plane, X } from 'lucide-react';
import { PHONE, PHONE_RAW, SITE_DOMAIN, SITE_NAME, SITE_TAGLINE } from '../constants/site';
import './MobileSupportPopup.css';

const FLIGHT_SUPPORT_ITEMS = [
  'Flight Booking',
  'Manage Booking',
  'Cancellation',
  'Customer Services',
];

const POPUP_STORAGE_KEY = 'farenodex_mobile_support_popup_dismissed';

export default function MobileSupportPopup() {
  const [isOpen, setIsOpen] = useState(false);

  const telHref = useMemo(() => `tel:${PHONE_RAW.replace(/[^\d+]/g, '')}`, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const shouldShowOnMobile = window.innerWidth <= 768;
    const isDismissed = window.sessionStorage.getItem(POPUP_STORAGE_KEY) === '1';

    if (!shouldShowOnMobile || isDismissed) {
      return undefined;
    }

    const timeout = window.setTimeout(() => {
      setIsOpen(true);
    }, 700);

    return () => window.clearTimeout(timeout);
  }, []);

  const closePopup = () => {
    setIsOpen(false);
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(POPUP_STORAGE_KEY, '1');
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="mobile-support-popup__backdrop" role="dialog" aria-modal="true" aria-label="Flight support popup">
      <div className="mobile-support-popup">
        <button type="button" className="mobile-support-popup__close" onClick={closePopup} aria-label="Close popup">
          <X size={20} />
        </button>

        <p className="mobile-support-popup__brand">{SITE_NAME}</p>
        <p className="mobile-support-popup__domain">{SITE_DOMAIN}</p>
        <h2 className="mobile-support-popup__title">Flight Reservations</h2>
        <p className="mobile-support-popup__subtitle">Click to Call Our Travel Expert</p>

        <a href={telHref} className="mobile-support-popup__phone-link">
          <Phone size={22} />
          <span>{PHONE}</span>
        </a>
        <p className="mobile-support-popup__support-text">24/7 Flight Booking Support</p>

        <div className="mobile-support-popup__grid" role="list" aria-label="Flight support categories">
          {FLIGHT_SUPPORT_ITEMS.map((item) => (
            <span key={item} className="mobile-support-popup__grid-item" role="listitem">
              {item}
            </span>
          ))}
        </div>

        <div className="mobile-support-popup__media" aria-hidden>
          <Plane size={58} strokeWidth={1.75} />
          <span className="mobile-support-popup__avatar">
            <Headphones size={34} />
          </span>
        </div>

        <p className="mobile-support-popup__tagline">{SITE_TAGLINE}</p>

        <a href={telHref} className="mobile-support-popup__offer">
          <span className="mobile-support-popup__offer-icon">
            <Phone size={22} />
          </span>
          <span className="mobile-support-popup__offer-copy">
            <small>Phone-Only Flight Deals</small>
            <strong>{PHONE}</strong>
          </span>
        </a>
      </div>
    </div>
  );
}
